import React from "react";
import { makeObservable, observable, runInAction } from "mobx";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { observer } from "mobx-react";

import type { UserData } from "./models";

import apiService from "@services/apiService";
import { userService } from "@services/userService";

import ErrorBoundary from "@components/ErrorBoundary";
import Page404 from "@pages/Page404";
import Chat from "@pages/Chat/Chat";
import ClientError from "@pages/ClientError";
import LoginPage from "@pages/LoginPage";
import SharedChat from "@pages/SharedChat";

import './App.css';
import './Scrollbars.css';
import './components/ContextMenu/_context-menu.scss';

declare global {
  interface Window {
    user?: UserData;
  }
}

@observer
class App extends React.Component {
  @observable UserData = window.user;
  @observable isLoading = true;

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }
  
  componentDidMount(): void {
    void this._checkUserLoggedIn();
  }

  render(){

    if (this.isLoading) {
      return null;
    }

    const isLoggedIn = !!window.user;
    return (
      <BrowserRouter>
        <ErrorBoundary fallback={(e) => <ClientError error={e} />}>
          <Routes>
            {!isLoggedIn ? (
              <>
                <Route
                  path="/share/:shareId"
                  element={
                    <SharedChat
                      shareId={
                        window.location.pathname.split("/share/")[1] || ""
                      }
                    />
                  }
                />              
                <Route path="/" element={<LoginPage />} />
                <Route path="*" element={<Page404 />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Chat />} />
                <Route
                  path="/share/:shareId"
                  element={
                    <SharedChat
                      shareId={
                        window.location.pathname.split("/share/")[1] || ""
                      }
                    />
                  }
                />
                <Route path="*" element={<Page404 />} />
              </>
            )}
          </Routes>
        </ErrorBoundary>
      </BrowserRouter>
    );
  }
  
  private async _checkUserLoggedIn() {
    let isLoggedIn = !!window.user;
    if (!isLoggedIn) {
      const userDataResponse = await fetch('/auth/userinfo');
      if (userDataResponse.ok) {
        const userData: { isAuthenticated: boolean; user?: UserData; hasRefreshToken?: boolean } = await userDataResponse.json();
        if (userData.isAuthenticated && userData.user) {
          window.user = userData.user;
          this.UserData = userData.user;
        }

        if (userData.hasRefreshToken) {
          await apiService.refreshToken(void 0, false);
        }
      }
    }
    runInAction(() => {
      this.isLoading = false;
    });
    await userService.loadUserSettings();
  }

};

export default App;